import { Routes, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/Home/Home';
import About from './pages/About/About';
import Offer from './pages/Offer/Offer';
import Contact from './pages/Contact/Contact';


export default function App() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/o-mnie" element={<About />} />
        <Route path="/oferta" element={<Offer />} />
        <Route path="/kontakt" element={<Contact />} />
      </Routes>
      <Footer />
    </div>
  );
}

